import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import { PartnersTableDefinitionZod } from '../tables';

type Arguments = Record<string, never>;

export const schemaPartnerResolver_GetPotentialTipsters = z.array(PartnersTableDefinitionZod);

export type SchemaPartnerResolver_GetPotentialTipsters = z.infer<typeof schemaPartnerResolver_GetPotentialTipsters>;
export type PartnerResolver_GetPotentialTipsters = Resolver<Arguments, SchemaPartnerResolver_GetPotentialTipsters>;
